import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {View, Text, ActivityIndicator, Modal} from 'react-native';

import styled from 'styled-components/native';
import {WorkoutCommonButton, WorkoutTextSubHeader, WorkoutContainerText} from "../styles/common-styles";
import {clearWorkoutStoreModalMessage} from "../reducers/cbcWorkoutSlice";
import {clearActivityStoreModalMessage} from "../reducers/cbcActivityActionsSlice";

function DynamicModal(props) {
    console.log(props);
    const {callback} = props;

    const {workout_modal_messaging} = useSelector((state) => state.cbcWorkout);
    const {activity_modal_messaging} = useSelector((state) => state.activityActions);
    const pageToNavigateTo = useSelector((state) => state.pvtDeepLinkManager.pageToNavigateTo);

    const [modalVisible, setModalVisible] = useState(false);
    const [headerImg, setHeaderImg] = useState('');
    const [headerText, setHeaderText] = useState('');
    const [bodyText, setBodyText] = useState('');
    const [modalExerciseContent, setModalExerciseContent] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
        if (props.modal_message_exercise && Object.keys(props.modal_message_exercise).length > 0) {
            setHeaderImg(props.modal_message_exercise.header_img);
            setHeaderText(props.modal_message_exercise.header_text);
            setBodyText(props.modal_message_exercise.body_text);
            setModalVisible(true);
        } else if (workout_modal_messaging && Object.keys(workout_modal_messaging).length > 0) {
            setHeaderImg(workout_modal_messaging.header_img);
            setHeaderText(workout_modal_messaging.header_text);
            setBodyText(workout_modal_messaging.body_text);
            setModalVisible(true);
        } else if (activity_modal_messaging && Object.keys(activity_modal_messaging).length > 0) {
            setHeaderImg(activity_modal_messaging.header_img);
            setHeaderText(activity_modal_messaging.header_text);
            setBodyText(activity_modal_messaging.body_text);
            setModalVisible(true);
        } else {
            setModalVisible(false);
        }
        console.log('MESSAGING: ', props.modal_message_exercise , workout_modal_messaging , activity_modal_messaging)
    }, [props.modal_message_exercise, workout_modal_messaging, activity_modal_messaging]);

    useEffect(() => {
        if(pageToNavigateTo.length !== 0){
            setModalVisible(false);
        }
    }, [pageToNavigateTo , props.modal_message_exercise, workout_modal_messaging, activity_modal_messaging]);

    function exit(){
        console.log('exit pressed');
        setModalVisible(false);
        dispatch(clearActivityStoreModalMessage())
        dispatch(clearWorkoutStoreModalMessage())
        if(typeof callback == 'function') {
            callback();
        }
    };

    return (
        <Modal visible={modalVisible} animationType="slide" transparent={true}>
            <DynamicModalParent>
                <DynamicModalContainer>
                    <DynamicModalHeader>
                        <DynamicModalHeaderImg src={headerImg}/>
                    </DynamicModalHeader>
                    <DynamicModalBody>
                        <DynamicModalHeaderText>{headerText}</DynamicModalHeaderText>
                        <DynamicModalBodyText>{bodyText}</DynamicModalBodyText>
                    </DynamicModalBody>
                    <DynamicModalFooter>
                        <DynamicModalExit onPress={() => exit()}>
                            <DynamicModalExitText>CONTINUE</DynamicModalExitText>
                        </DynamicModalExit>
                    </DynamicModalFooter>
                </DynamicModalContainer>
            </DynamicModalParent>
        </Modal>
    );
}

const DynamicModalParent = styled.View`
  flex: 1;
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const DynamicModalContainer = styled.View`
  background-color: #fff;
  border-radius: 10px;
  padding: 25px;
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

const DynamicModalHeader = styled.View`
  align-items: center;
  margin-bottom: 20px;
`;

const DynamicModalHeaderImg = styled.Image`
  width: 300px;
  height: 100px;
  border-radius: 50px;
`;

const DynamicModalHeaderText = styled(WorkoutTextSubHeader)`
  font-family: 'Montserrat-EB';
  letter-spacing: 0.5px;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  width: 100%;
  text-align: center;
`;

const DynamicModalBody = styled.View`
  margin-bottom: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const DynamicModalBodyText = styled(WorkoutContainerText)`
  text-align: center;
`;

const DynamicModalFooter = styled.View`
  align-items: center;
`;

const DynamicModalExit = styled(WorkoutCommonButton)`
  height: 35px;
  width: 125px;
  padding-left: 0;
  padding-right: 0;
`

const DynamicModalExitText = styled.Text`
  font-family: 'Montserrat-SB';
  font-size: 13px;
  color: white;
  letter-spacing: 2px;
`;
export default DynamicModal;